import { render, staticRenderFns } from "./PayrollPreviewSummary.vue?vue&type=template&id=6dd2f241"
import script from "./PayrollPreviewSummary.vue?vue&type=script&lang=js"
export * from "./PayrollPreviewSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports